import { styled } from 'linaria/react';
import { theme } from '../Theming/Theming';

export const ProductListHeader = styled('h2')`
  padding: 1rem 0 2rem;
  width: 100%;
  text-align: center;
  color: ${theme.productPage.productList.headerColor};
  font-family: ${theme.font.secondary};
  text-transform: none;
  font-weight: normal !important;
`;

export const ProductListSubHeader = styled('h3')`
  padding: 1rem 0 1rem;
  width: 100%;
  text-align: center;
  color: ${theme.productPage.productList.subHeaderColor};
  font-family: ${theme.font.secondary};
  text-transform: none;
  font-weight: normal !important;
`;

export const ProductInfoMarginBottom = `
  margin-bottom: 0.6rem;
  ${theme.above.md} {
    margin-bottom: 1rem;
  }
`;
